/**
 * @owner @Appboy/messaging-experience
 */

import { campaignRemoteLookupValidators } from "@schemas/remoteLookup/campaignRemoteLookupSchema";
import type { CampaignRemoteLookupId, CampaignRemoteLookupItem, CampaignRemoteLookupFilters } from "@schemas/types";
import type { z } from "zod";

import type { RemoteLookupProvider } from "./types";

export const campaignProvider: RemoteLookupProvider<
  CampaignRemoteLookupId,
  CampaignRemoteLookupItem,
  CampaignRemoteLookupFilters
> = {
  mapItemToId: (item) => item.id,
  mapIdToString: (id) => id,
  // The backend searches on :name; campaigns can be unnamed, so fall back to "".
  mapItemToSearchString: (item) => item.name ?? "",
  validators: {
    ...campaignRemoteLookupValidators,
    // The generated nullable-name validator doesn't structurally satisfy
    // z.ZodType<CampaignRemoteLookupItem> under Zod's invariance; cast as the
    // other providers with optional fields (e.g. appProvider) do.
    item: campaignRemoteLookupValidators.item as z.ZodType<CampaignRemoteLookupItem>,
  },
};
